const CM_TO_INCHES = 0.39370;

const centimetersToInches = (centimeters, returnAsFloat = false) => {
	if (returnAsFloat !== false) return (centimeters * CM_TO_INCHES).toFixed(returnAsFloat);
	const inches = (centimeters * CM_TO_INCHES).toFixed(5);

	const wholeInches = Math.floor(inches);
	const remainder = parseInt(inches.toString().split('.')[1], 10);
	let denominator = 16;
	let numerator = Math.round(16 * (remainder * 0.00001));
	// reduce the fraction
	while (numerator && numerator % 2 === 0) {
		numerator /= 2;
		denominator /= 2;
	}

	return {
		wholeInches,
		numerator,
		denominator,
	};
};

export { centimetersToInches };
